import { initializeApp, getApps } from 'firebase/app';
import { getDatabase, ref } from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** Match Edge path sanitizer. */
export function sanitizeArticleIdForClient(raw) {
  if (raw == null) return '';
  return String(raw).trim().replace(/[^a-zA-Z0-9_-]/g, '');
}

export function isFirebaseArticleCommentsConfigured() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.databaseURL);
}

export function initFirebaseArticleComments() {
  if (getApps().length > 0) return true;
  if (!isFirebaseArticleCommentsConfigured()) return false;
  initializeApp(firebaseConfig);
  return true;
}

export function articleCommentsRef(articleId) {
  const id = sanitizeArticleIdForClient(articleId);
  if (!id) return null;
  return ref(getDatabase(), `articleComments/${id}/comments`);
}
